import { render } from "./Download&Use.md?vue&type=template&id=44d3a28a"
const script = {}
script.render = render

export default script